/**
 defines the UX for the case when we want to show only a certain number of elements on page at load AND don't mind
 having all results loaded directly into javascript (i.e. for very large collections, this element shouldnt be used)
 **/

/**
 * Results are an unstructured (in the sense that there's no backing model) collection of elements which we want to page
 * through
 */
const Results = Backbone.Collection.extend({
});


/**
 * a Pager is the data model for scrolling through pages of Results
 */
const Pager = Backbone.Model.extend({
    defaults: {
        pageSize: 5,
        currentPage: 0
    },

    /**
     * the start index, as a function of the pageSize and currentPage values
     */
    startIx() {
        return this.get('pageSize') * this.get('currentPage');
    },

    /**
     * the end index of pagination, as a function of the start index and page size
     */
    endIx() {
        return this.startIx() + this.get('pageSize');
    }
});


/**
 * the MoreResultsView shows the results of paging operations. Importantly, it appends loaded results to its container element
 * (rather than replacing contents). Therefore, it should be noted that going backwards (removing data) is difficult
 */
const MoreResultsView = Backbone.View.extend({
    initialize(opts) {
        this.template = opts.template;

        this.model.on('change:currentPage', this.render, this);
    },

    render() {
        let page = this.collection.models.slice(this.model.startIx(), this.model.endIx());

        this.$el.append(
            page.map(p => this.template(p.attributes))
        );
    }
});


const MoreResultsTrigger = Backbone.View.extend({
    events: {
        'click': 'loadResults'
    },

    initialize() {
        this.model.on('change:currentPage', this.render, this);
    },

    loadResults() {
        this.model.set({currentPage: this.model.get('currentPage') + 1})
    },

    render() {
        // if no more data remains, remove the trigger
        if (this.model.endIx() > this.collection.size()) {
            console.log("**no more data to load**");
            this.$el.remove();
        }
    }
});


let creator = (resultsContainer, pagerTrigger, opts) => {
    opts = opts || {};

    let initialResults = opts.initialResults || [];
    let initialPage = opts.initialPage || 0; // the page to start results from
    let pageSize = opts.pageSize || 5; // the size of a page of results
    let resultTemplate = opts.resultTemplate; // the template for a single result

    if (!resultTemplate) {
        throw "a result template is required for result pagination"
    }

    let results = new Results(initialResults);
    let pager = new Pager({
        currentPage: initialPage,
        pageSize: pageSize
    });

    new MoreResultsView({
        el: resultsContainer,
        template: resultTemplate,
        model: pager,
        collection: results
    });

    new MoreResultsTrigger({
        el: pagerTrigger,
        model: pager,
        collection: results
    });
};

module.exports = creator;


// WEBPACK FOOTER //
// ./assets/js/app/lib/more-results.js